/* src/app/components/assessment-list/assessment-list.component.scss */
.material-icons-down-icon {
  top: 7px;
  position: relative;
  left: 4px;
  color: white;
}
.caret-icons-up-icon {
  top: -2px;
  position: relative;
  left: -5px;
  color: white;
}
.caret-drop-icons-up-icon {
  top: -2px;
  position: relative;
  left: -5px;
  color: white;
}
.row1 {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.font-color {
  color: white;
  height: 42px;
}
.header-row {
  background: #f0f3f4;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-top: 3px solid #d1dbde;
}
.table-row-child {
  font-size: 14px;
  padding: 15px;
  display: flex;
  align-items: center;
}
.table-row-child label {
  font-weight: 400;
}
.icon-container-title .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.dpg-icon-hamburger-white {
  position: relative;
  padding-top: 5px;
  right: 15px;
  height: 27px;
  width: 18px;
}
.dpg-icon-system-sort-up-white {
  position: relative;
  right: 22px;
}
.dpg-icon-system-sort-down-white {
  position: relative;
  right: 22px;
}
.icon-container-isbn .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.icon-container-author .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.icon-container-edition .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.icon-container-avl .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.padding-30 {
  padding: 30px;
}
.margin-top-1 {
  margin-top: -1px;
}
.margin-top-one {
  margin-top: 1px;
}
.margin-bottom-30 {
  margin-bottom: 30px;
}
.parent-search-div {
  display: flex;
  justify-content: flex-end;
}
.search-component {
  width: 238px;
  margin-top: -1px;
  height: 36px;
}
.header-actions {
  display: flex;
}
.set-margin {
  margin-top: -36px;
  margin-left: -25px;
}
.left-upload {
  padding-left: 5px;
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
}
.upload-div {
  padding-left: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 78%;
}
.upload-div input:first-child {
  flex: 1;
  min-width: 0;
}
.upload-div .clear-button {
  background-color: #ffffff;
  border: none;
  flex-shrink: 0;
  height: 24px;
  padding: 0;
  width: 24px;
}
.upload-div .clear-button:active,
.upload-div .clear-button:focus {
  border: 1px solid #174d5c;
}
.import-text {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
  color: #000000;
  margin-left: -1px;
  margin-bottom: 40px;
}
.text-color {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 15px;
  color: #222222;
}
.icon-container .dpg-icon-system-sort-white {
  position: relative;
  right: 22px;
}
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.assesment-position {
  position: relative;
  top: 5px;
}
.page-link {
  background-color: #ddd;
  color: black;
  border: 5px solid white;
}
.page-link:hover {
  background-color: black;
  color: white;
  border: 5px solid white;
}
.material-icons-pagination {
  top: 16px;
  position: relative;
}
.button-position {
  position: relative;
  bottom: 2px;
}
.btn-secondary {
  color: black;
  background-color: #ddd;
  border: none;
}
.textstyle {
  background-color: #eaebec;
  font-weight: normal;
  border-radius: 22px;
  width: auto;
  height: auto;
  padding: 5px 10px 5px 10px;
  font-size: 13px;
  color: black;
}
.textstyle a {
  color: #fff;
  text-decoration: underline;
}
.search-icon-style {
  background-color: #ddd;
  font-weight: bold;
  border-radius: 4px;
  height: 30px;
  padding: 6px 12px 5px 18px;
  font-size: 15px;
  color: black;
  margin-left: 10px;
}
.cursor-style {
  cursor: pointer;
}
.page-title {
  font-size: 20px;
}
.page-title h1 {
  font-weight: 400;
  line-height: 1.5;
  color: #46707d;
  font-size: 20px;
  margin-top: 1px;
  margin-bottom: 0;
}
.workspace__header {
  width: 100%;
  padding: 20px 25px 0;
}
.collection-list-header {
  background: #007c91;
  display: flex;
  align-items: center;
  height: 45px;
}
.sort-btn {
  height: 20px;
  position: absolute;
  right: 8px;
  top: 10px;
  width: 20px;
  visibility: hidden;
  display: block;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}
.close {
  height: 14px;
  width: 14px;
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  filter: alpha(opacity=30);
}
.modal-content {
  z-index: 1010;
  text-align: left;
}
.modal-dialog {
  position: relative;
  top: 50%;
  width: 300px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info {
  position: fixed;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
.modal-dialog-more-info-new {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info-new .modal-content {
  height: auto;
}
.modal-dialog-more-info-new .modal-content .iframe-body-single {
  height: 380px;
  width: 552px;
}
.modal-dialog-more-info-new .modal-content .iframe-body-multiple {
  height: 284px;
  width: 552px;
}
.modal-dialog-copy {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-copy .modal-content {
  height: 250px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background: #007c91;
  padding: 5px 30px;
  color: #fff;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.status {
  margin-right: 10px;
}
.status:focus {
  outline: 1px solid #007c91;
  box-shadow: 0 0 0 2px rgba(0, 124, 145, 0.8);
}
.buttonsPanel {
  border-top: none;
  padding-left: 10px;
}
.refreshDiv {
  max-width: 50px !important;
  padding-right: 12px;
  margin-right: 10px;
  margin-left: 10px;
  bottom: 1px;
  position: relative;
}
.dateAlign {
  padding: 4px 0;
  top: 9px;
  position: relative;
}
.buttonsAlign {
  bottom: 3px;
  position: relative;
  padding: 0;
}
.fileIconOneAlign {
  position: relative;
  bottom: 4px;
}
.fileIconTwoAlign {
  position: relative;
  bottom: 15px;
}
.availabilityOneAlign {
  padding-top: 10px;
}
.availabilityTwoAlign {
  padding-top: 8px;
}
.margin-colnstitle {
  margin-left: 20px;
}
.refresh-btn {
  margin: -2px 13px 0px;
}
.modal-header .modal-footer {
  display: block !important;
}
::ng-deep .dropdown-btn {
  background: #007c91 !important;
  color: white !important;
}
::ng-deep .dpg-icon-dropdown-arrow-down::before {
  content: url("data:image/svg+xml;charset=utf8, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M6.343 10.343L12 16l5.657-5.657-1.414-1.414L12 13.172 7.757 8.929z'/%3E%3C/svg%3E") !important;
}
::ng-deep .dpg-icon-dropdown-arrow-down {
  transition: transform 0.2s ease;
}
::ng-deep .dropdown-btn.open .dpg-icon-dropdown-arrow-down {
  transform: rotate(180deg);
}
::ng-deep .ahe-ui-dropdown .dropdown-menu li a.dropdown-item {
  padding: 7px !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}
.link-style {
  background: none;
  border: none;
  color: #007c91;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}
.link-style:hover,
.link-style:focus {
  text-decoration: underline;
  outline: 1px solid #007c91;
  box-shadow: 0 0 0 2px rgba(0, 124, 145, 0.8);
}
::ng-deep .modal-dialog .modal-content .modal-footer {
  padding: 8px !important;
}
@media (max-width: 767px) {
  .container-fluid {
    padding: 16px 8px;
  }
  .heading-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .heading-row .workspace_header h1 {
    margin-bottom: 8px;
  }
  .heading-row .parent-search-div {
    margin-top: 8px;
  }
  .search-component {
    width: 100%;
  }
  .refresh-btn,
  .assesment-dropdown {
    margin: 0;
  }
  .upload-div {
    width: 100%;
    padding-left: 5px;
  }
}
@media (max-width: 575px) {
  .parent-search-div {
    flex-direction: column;
    align-items: flex-start;
  }
  .refresh-btn,
  .assesment-dropdown {
    padding: 8px 8px 0 0;
  }
}
.link-style {
  background: none;
  border: none;
  color: #007c91;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}
.link-style:hover,
.link-style:focus {
  text-decoration: underline;
  outline: 1px solid #007c91;
  box-shadow: 0 0 0 2px rgba(0, 124, 145, 0.8);
}
table {
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}
table th.sticky-col > span {
  font-size: 14px;
}
@media (max-width: 992px) {
  .container-fluid {
    padding: 16px 0px;
  }
  .main-content {
    padding-left: 0px;
    padding-right: 0px;
  }
  .heading-row {
    padding-left: 15px;
    padding-right: 15px;
  }
  .assessment-list-table {
    width: 100%;
  }
  table th,
  table td {
    font-size: 12px;
    font-weight: 600;
    word-wrap: break-word;
  }
  .main-content .row1,
  .main-content .row {
    margin-left: 0px;
    margin-right: 0px;
  }
  table th:nth-child(1),
  table td:nth-child(1) {
    width: 18%;
  }
  table th:nth-child(2),
  table th:nth-child(3),
  table th:nth-child(4),
  table td:nth-child(2),
  table td:nth-child(3),
  table td:nth-child(4) {
    width: 15%;
  }
  table th:nth-child(5),
  table th:nth-child(6),
  table td:nth-child(5),
  table td:nth-child(6) {
    width: 13%;
  }
  table th:nth-child(7),
  table td:nth-child(7) {
    width: 11%;
  }
}
@media (max-width: 640px) {
  .assessment-list-table {
    overflow: auto;
    overflow-x: scroll;
    scrollbar-width: auto;
    -ms-overflow-style: auto;
  }
  .row1 {
    margin: 0px;
  }
  .assessment-list-table::-webkit-scrollbar {
    height: 8px;
    background-color: #f1f1f1;
  }
  .assessment-list-table::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 4px;
  }
  table {
    display: block;
    width: max-content;
  }
  .sticky-col {
    position: sticky;
    right: 0;
    z-index: 1;
    float: right;
  }
  .sticky-col div {
    justify-content: center;
  }
  th.sticky-col {
    background-color: #007c91;
    padding: 10px 0px;
  }
  td.sticky-col {
    background-color: #FFFFFF;
    padding: 10px 0px;
  }
  table tr {
    position: relative;
  }
}
@media (max-width: 420px) {
  .assessment-list-table {
    width: 715px;
    max-width: 100%;
    overflow: auto;
    overflow-x: scroll;
    scrollbar-width: auto;
    -ms-overflow-style: auto;
  }
  table th:nth-child(1),
  table td:nth-child(1) {
    width: 148px;
  }
  table th:nth-child(2),
  table th:nth-child(3),
  table th:nth-child(4),
  table td:nth-child(2),
  table td:nth-child(3),
  table td:nth-child(4) {
    width: 107px;
  }
  table th:nth-child(5),
  table th:nth-child(6),
  table td:nth-child(5),
  table td:nth-child(6) {
    width: 90px;
  }
  table th:nth-child(7),
  table td:nth-child(7) {
    width: 66px;
  }
  table {
    display: block;
    width: max-content;
  }
}
tbody tr:last-child td {
  border-bottom: none;
}
.icon-container,
.icon-container-title,
.icon-container-isbn,
.icon-container-author,
.icon-container-edition,
.icon-container-avl {
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
}
thead tr.row th > button.header-sort-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
}
thead tr.row th > button.header-sort-button span {
  position: relative;
  right: 23px;
}
thead tr.row th span {
  font-size: 16px;
  font-weight: 700;
}
tbody tr td:last-child .table-row-child {
  justify-content: center;
}
/*# sourceMappingURL=assessment-list.component.css.map */
